<template>
  <div
    class="countdown"
    :style="{
      '--bg-color': backgroundColor,
      '--numbers-color': numbersColor,
    }"
  >
    <div class="time-part">
      <div class="time-part__value">
        {{ remaingTime.days | twoDigits }}
      </div>
      <div class="time-part__label">
        {{ $tc('days', remaingTime.days) }}
      </div>
    </div>
    <div class="time-part">
      <div class="time-part__value">
        {{ remaingTime.hours | twoDigits }}
      </div>
      <div class="time-part__label">
        {{ $tc('hours', remaingTime.hours) }}
      </div>
    </div>
    <div class="time-part">
      <div class="time-part__value">
        {{ remaingTime.minutes | twoDigits }}
      </div>
      <div class="time-part__label">
        {{ $tc('minutes', remaingTime.minutes) }}
      </div>
    </div>
    <div class="time-part">
      <div class="time-part__value">
        {{ remaingTime.seconds | twoDigits }}
      </div>
      <div class="time-part__label">
        {{ $tc('seconds', remaingTime.seconds) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Timer',
  filters: {
    twoDigits(number) {
      return number < 10 ? `0${number}` : number;
    },
  },
  props: {
    instanceId: {
      type: String,
      default: '',
    },
    dateString: {
      type: String,
      default: '',
    },
    numbersColor: {
      type: String,
      default: '#ffffff',
    },
    backgroundColor: {
      type: String,
      default: '#3e9aa6',
    },
  },
  data() {
    return {
      now: new Date(),
      interval: null,
    };
  },
  computed: {
    targetDate() {
      return new Date(this.dateString);
    },
    timeIsUp() {
      return this.now >= this.targetDate;
    },
    remaingTime() {
      const remaingTimeInSecs = Math.floor((this.targetDate - this.now) / 1000);

      if (remaingTimeInSecs < 0) {
        return {
          seconds: 0,
          minutes: 0,
          hours: 0,
          days: 0,
        };
      }

      return {
        seconds: remaingTimeInSecs % 60,
        minutes: Math.floor(remaingTimeInSecs / 60) % 60,
        hours: Math.floor(remaingTimeInSecs / 60 / 60) % 24,
        days: Math.floor(remaingTimeInSecs / 60 / 60 / 24),
      };
    },
  },
  watch: {
    dateString() {
      this.start();
    },
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      this.stop();

      if (!this.timeIsUp) {
        this.$emit('start');

        this.interval = window.setInterval(() => {
          this.now = new Date();

          if (this.timeIsUp) {
            this.stop();
            this.$emit('end');
          }
        }, 1000);
      } else {
        this.$emit('end');
      }
    },
    stop() {
      window.clearInterval(this.interval);
    },
  },
  i18n: {
    messages: {
      // '0 | 1 | 1+'
      pt: {
        days: 'Dia | Dia | Dias',
        hours: 'Hora | Hora | Horas',
        minutes: 'Minuto | Minuto | Minutos',
        seconds: 'Segundo | Segundo | Segundos',
      },
      en: {
        days: 'Day | Day | Days',
        hours: 'Minute | Minute | Minutes',
        minutes: 'Hour | Hour | Hours',
        seconds: 'Second | Second | Seconds',
      },
      es: {
        days: 'Dia | Dia | Dias',
        hours: 'Hora | Hora | Horas',
        minutes: 'Minuto | Minuto | Minutos',
        seconds: 'Segundo | Segundo | Segundos',
      },
    },
  },
};
</script>

<style scoped lang="scss">
.countdown {
  margin: 0 auto;
  position: relative;
  max-width: $lb-main-width;
  text-align: center;
  display: flex;
  justify-content: space-between;

  .time-part + .time-part {
    margin-left: 20px;
  }

  .time-part {
    min-width: 80px;
    position: relative;

    &__value {
      color: var(--numbers-color);
      background-color: var(--bg-color);
      padding: 4px;
      font-size: 24px;
      font-weight: $lb-medium;
      border-radius: 4px;
    }

    &__label {
      font-size: $size-smaller;
      line-height: 1em;
      text-transform: lowercase;
      margin-top: 0.5em;
    }
  }
}

@include media-breakpoint-down(sm) {
  .countdown {
    .time-part + .time-part {
      margin-left: auto;
    }

    .time-part {
      min-width: 56px;
      &__value {
        font-size: 22px;
      }

      &__label {
        font-size: 8px;
      }
    }
  }
}
</style>
